import { render } from "./BannerClassify.vue?vue&type=template&id=6a8099a0&scoped=true&ts=true"
import script from "./BannerClassify.vue?vue&type=script&lang=ts"
export * from "./BannerClassify.vue?vue&type=script&lang=ts"

import "./BannerClassify.vue?vue&type=style&index=0&id=6a8099a0&lang=scss&scoped=true"

import exportComponent from "G:\\Runze\\rzhy_main_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a8099a0"]])

export default __exports__